/**
 * OJI MATCHA: Header Pill Morph Search v2
 * Minimal enhancements - theme handles core functionality
 * This just auto-focuses input when search opens
 */
(function() {
  'use strict';

  // Only run on desktop
  if (window.innerWidth < 1025) return;

  function init() {
    // Find the search details element
    const searchDetails = document.querySelector('.header-nav-hamburger .search_details--popup, .header-nav-hamburger .search_details');
    if (!searchDetails) return;

    const searchInput = searchDetails.querySelector('.search__input');
    if (!searchInput) return;

    // Watch for the details opening and auto-focus the input
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (searchDetails.open) {
            // Auto-focus input with a slight delay for animation
            setTimeout(function() {
              searchInput.focus();
            }, 100);
          }
        }
      });
    });

    observer.observe(searchDetails, { attributes: true });

    // Also watch for the sticky-search-menu-open class on body
    // This is added by the theme when search opens
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const body = document.body;
          if (body.classList.contains('sticky-search-menu-open') || 
              body.classList.contains('sticky-search-menu-custom-open')) {
            // Auto-focus input
            setTimeout(function() {
              const input = document.querySelector('.header-nav-hamburger .search__input');
              if (input) input.focus();
            }, 150);
          }
        }
      });
    });

    bodyObserver.observe(document.body, { attributes: true });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on resize (desktop ↔ mobile)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth >= 1025) {
        init();
      }
    }, 250);
  });
})();
